// Tus llaves de conexión a Firebase (Realtime Database).
// Este archivo solo GUARDA la configuración; la conexión real
// se hace en live-shopping.js y live-shopping-control.js.
window.firebaseConfig = {
  apiKey: "AIzaSyANHPJFtfvBvohh3LKyGSRMDi7AjbeztYE",
  authDomain: "live-panel-c52a0.firebaseapp.com",
  databaseURL: "https://live-panel-c52a0-default-rtdb.firebaseio.com",
  projectId: "live-panel-c52a0",
  storageBucket: "live-panel-c52a0.firebasestorage.app",
  messagingSenderId: "578135699902",
  appId: "1:578135699902:web:5a8430627aee97b9d709ef"
};
